import { useId, type ElementType } from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

export function SettingToggleCard({ title, description, icon: Icon, checked, onChange, disabled }: {
  title: string; description: string; icon: ElementType; checked: boolean;
  onChange: (checked: boolean) => void; disabled?: boolean;
}) {
  const id = useId();
  return <section className="flex items-center justify-between gap-4 rounded-xl border border-gray-200 bg-white p-5">
    <div className="flex items-start gap-3">
      <span aria-hidden className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary"><Icon size={20} /></span>
      <div>
        <div className="flex flex-wrap items-center gap-2"><label htmlFor={id} className="text-base font-semibold text-gray-900">{title}</label>
          <span className={checked ? 'rounded-md bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700' : 'rounded-md bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-500'}>{checked ? 'Ativo' : 'Inativo'}</span>
        </div>
        <p id={id + '-description'} className="mt-1 text-sm text-gray-500">{description}</p>
      </div>
    </div>
    <SwitchPrimitive.Root id={id} aria-describedby={id + '-description'} checked={checked} onCheckedChange={onChange} disabled={disabled}
      className="h-6 w-11 shrink-0 rounded-full bg-gray-300 p-0.5 outline-none transition-colors focus-visible:ring-2 focus-visible:ring-primary/30 data-[state=checked]:bg-primary disabled:cursor-not-allowed disabled:opacity-50">
      <SwitchPrimitive.Thumb className="block h-5 w-5 rounded-full bg-white shadow transition-transform data-[state=checked]:translate-x-5" />
    </SwitchPrimitive.Root>
  </section>;
}
